module.exports = __webpack_public_path__ + "static/csv-file-95df078cd14f4a14e7ee6b707ea4cf13.svg";